import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../../public/icon-font/app-icons.woff2\",\"variable\":\"--font-icons\",\"display\":\"block\",\"weight\":\"400\",\"style\":\"normal\",\"preload\":true}],\"variableName\":\"iconFont\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/theme/fonts.ts\",\"import\":\"Work_Sans\",\"arguments\":[{\"weight\":[\"400\",\"700\",\"900\"],\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--work-sans\"}],\"variableName\":\"work_sans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["PrerenderReady"] */ "/app/src/components/PrerenderReady/PrerenderReady.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/localization/hooks/useLanguageChange.ts");
;
import(/* webpackMode: "eager", webpackExports: ["CommonStoreProvider"] */ "/app/src/store/commonStore/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/styles/registry.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/seo.css");
